/**
 * View Cash-in cho BIDV — bám `frmFuturesQryBankCashInBIDV` (form Access, RecordSource giống VTB/MBB
 * nhưng tách form GUID riêng). Storage key & file riêng để sau này có thể tách columns/format
 * nếu BIDV cần khác (vd mặc định ẩn 2 cột USD vì BIDV vận hành USD).
 */
import BankCashInDataSheet from './BankCashInDataSheet'
import type { BankCashInRow, BankName } from './BankCashInDialog'
import type { ReactNode } from 'react'

interface Props {
  bank: Extract<BankName, 'BIDV'>
  selectedKey: string | null
  onSelectionChange: (row: BankCashInRow | null) => void
  actionsSlot?: ReactNode
}

export default function FuturesBankCashInBIDVView({ bank, selectedKey, onSelectionChange, actionsSlot }: Props) {
  return (
    <BankCashInDataSheet
      bank={bank}
      columnsStorageKey="futures-cols-bank-cash-bidv-v1"
      selectedKey={selectedKey}
      onSelectionChange={onSelectionChange}
      actionsSlot={actionsSlot}
    />
  )
}
